import {
  IMAGES_PANEL_MASONRY_COLS,
  IMAGES_PANEL_MASONRY_GAPS,
  IMAGES_PANEL_SKELETON_HEIGHTS,
} from "../constants";
import { ImageSkeleton } from "./image-skeleton";

const HEIGHTS = IMAGES_PANEL_SKELETON_HEIGHTS;
const GAPS = IMAGES_PANEL_MASONRY_GAPS;
const COLS = IMAGES_PANEL_MASONRY_COLS;

interface IProps {
  noAnim?: boolean;
}

export const StockSkeleton = ({ noAnim }: IProps) => {
  return (
    <div
      className="tw-grid tw-size-full tw-grid-flow-col tw-overflow-hidden tw-px-6"
      style={{ columnGap: GAPS }}
    >
      {Array.from({ length: COLS }, (_, idx) => (
        <ColSkeleton
          key={idx}
          heights={HEIGHTS[idx % HEIGHTS.length]}
          noAnim={noAnim}
        />
      ))}
    </div>
  );
};

const ColSkeleton = ({ heights, noAnim }: { heights: number[] } & IProps) => {
  return (
    <ul className="tw-mt-4 tw-grid tw-list-none tw-content-start tw-gap-2">
      {Array.from({ length: 12 }, (_, idx) => (
        <li
          key={idx}
          style={{
            height: heights[idx % heights.length],
          }}
        >
          <ImageSkeleton noAnim={noAnim} />
        </li>
      ))}
    </ul>
  );
};
